export const testimonials = [
    {
      name: "Dr. Jane Davis",
      role: "Emergency Physician",
      initials: "JD",
      review: "After trying numerous brands, EliteMed has become my go-to. The comfort during 12-hour shifts is unmatched, and they still look professional after countless washes."
    },
    {
      name: "Nurse Mike Chen",
      role: "ICU Nurse",
      initials: "MC",
      review: "The fit is perfect and the fabric breathes so well. I've recommended EliteMed to my entire team."
    },
    {
      name: "Dr. Sarah Williams",
      role: "Pediatric Nurse",
      initials: "SW",
      review: "Love the variety of colors and the professional appearance. The pockets are perfectly placed for all my essentials."
    }
  ];